<template>
    <button
        :class="allClasses"
        class="rsv-button"
        @click.prevent="onClick($event)"
        v-loading="loading"
        :disabled="disabled"
    >
        {{ text }}
    </button>
</template>

<script>

export default {
    name: 'RsvButton',
    props: {
        addClass: {
            type: String,
            default: '',
        },
        color: {
            type: String,
            default: 'default',
        },
        weight: {
            type: String,
            default: 'normal',
        },
        text: {
            type: String,
        },
        noindent: {
            type: Boolean,
            default: false,
        },
        loading : {
            type: Boolean,
            default: false,
        },
        reset : {
            type: Boolean,
            default: false,
        },
        small: {
            type: Boolean,
            default: false,
        },
        outline: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed : {
        classStyle() {
            return {
                'rsv-button_indent_none': this.noindent,
                'rsv-button_indent_small': this.small,
                'rsv-button_size_small': this.small,
                'rsv-button_outline': this.outline,
            };
        },
        className() {
            return this.reset
                ? 'rsv-button_style_reset'
                : `rsv-button_style_default rsv-button_color_${this.color} rsv-button_weight_${this.weight} ${this.addClass}`;
        },
        allClasses() {
            return [ this.className, this.classStyle ];
        },
    },
    methods : {
        onClick( event ) {
            this.$emit( 'click', event );
        },
    },
};
</script>

<style lang="scss" scoped>
@import "./rsv-button.scss";
@import '@/styles/rem';

.rsv-button_color_blue {
    font-family: Montserrat, sans-serif;
    padding: rem(14) rem(32);
    background: #4663AB !important;
    border-radius: rem(10);
    font-weight: 600;
    font-size: rem(14);
    line-height: rem(20);
    color: #FFFFFF;
}
.rsv-button {
  border-radius: rem(10);
  :deep(.vue-loading-spinner) {
    top: calc(50% - #{rem(18)});
    left: calc(50% - #{rem(18)});

    width: rem(36);
    height: rem(36);
  }
}
</style>

